import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../core/services/locatization.service';

@Pipe({ name: 'translateWithParams', standalone: true })
export class TranslateWithParamsPipe implements PipeTransform {
    private localizationService = inject(LocalizationService);

    transform(value: string): string {
        return this.localizationService.translate(value);
    }
}